import { useEventSource, useSubscribe } from 'remix-sse/client';

export default function useSubscribeUserSse<T>(eventKey: string, userId?: string): T | null {
  const sseUrl = `${process.env.REACT_APP_NOTIFICATION_SERVER_URL}/stream/${userId}`;
  useEventSource(sseUrl);

  return useSubscribe(sseUrl, eventKey, {
    returnLatestOnly: true,
    deserialize: raw => JSON.parse(raw) as T,
  });
}
